import React from 'react';
import './OperaCloudCompare.css';

// Shared routes builder — rows of (Configuration Set → Notification Target), both chosen by name but
// stored by id. A config set may be chosen at most once per project. Controlled: the parent owns
// `routes` = [{ config_set_id, notification_target_id }] and handles persistence.

const DryftRoutesEditor = ({ routes, configSets = [], targets = [], onChange, disabled = false }) => {
    const usedSets = new Set(routes.map(r => String(r.config_set_id)).filter(Boolean));

    const update = (i, patch) => onChange(routes.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
    const addRow = () => onChange([...routes, { config_set_id: '', notification_target_id: '' }]);
    const removeRow = (i) => onChange(routes.filter((_, idx) => idx !== i));

    const noLibs = configSets.length === 0 || targets.length === 0;

    return (
        <div className="dryft-routes">
            {noLibs && (
                <div className="occ-instance-hint" style={{ marginBottom: 8 }}>
                    {configSets.length === 0 && 'Create a Configuration Set first. '}
                    {targets.length === 0 && 'Create a Notification Target first.'}
                </div>
            )}
            {routes.map((r, i) => (
                <div key={i} className="dryft-route-row">
                    <select
                        className="ppw-input"
                        value={r.config_set_id || ''}
                        disabled={disabled}
                        onChange={e => update(i, { config_set_id: e.target.value })}
                    >
                        <option value="">Configuration set…</option>
                        {configSets.map(cs => (
                            <option
                                key={cs.id}
                                value={cs.id}
                                disabled={usedSets.has(String(cs.id)) && String(cs.id) !== String(r.config_set_id)}
                            >
                                {cs.name}
                            </option>
                        ))}
                    </select>
                    <span className="dryft-route-arrow">→</span>
                    <select
                        className="ppw-input"
                        value={r.notification_target_id || ''}
                        disabled={disabled}
                        onChange={e => update(i, { notification_target_id: e.target.value })}
                    >
                        <option value="">Notify…</option>
                        {targets.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                    </select>
                    <button
                        type="button"
                        className="dryft-route-remove"
                        onClick={() => removeRow(i)}
                        disabled={disabled}
                        aria-label="Remove route"
                    >×</button>
                </div>
            ))}
            <button type="button" className="occ-select-btn" onClick={addRow} disabled={disabled || noLibs}>
                + Add route
            </button>
        </div>
    );
};

export default DryftRoutesEditor;
